import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "/posts";
const PostApi = {
  posts(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  createPost(params: any) {
    return api.post(path, params);
  },

  detailPost(id: any, params: any) {
    return api.get(`${path}/${id}`, params);
  },

  updatePost(id: any, params: any) {
    return api.put(`${path}/${id}`, params);
  },

  deletePost(id: any) {
    return api.delete(`${path}/${id}`);
  },

  updateStatusPost(params: any) {
    return api.patch(`${path}/update-status`, params);
  },

  deleteMultiplePost(params: any) {
    return api.delete(`${path}/bulk-delete`, params);
  },

  updateSearchKeywordPost(params: any) {
    return api.post(`${path}/update-search-keywords-id`, params);
  },
};

export function uploadFiles(files: any) {
  const url = "/upload/files";
  return api.post(url, files, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export default PostApi;
